module.exports = __webpack_public_path__ + "img/logo-en.b944522a.svg";